<template>
  <transition name="fade">
    <div class="swipe-away-message">
      <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="42" height="40.21" viewBox="0 0 42 40.21"><path d="M41.89 28.15a25.66 25.66 0 0 0-1.58-6.44 15 15 0 0 0-3.15-5.18 4.31 4.31 0 0 0-4.79-1.2 5.84 5.84 0 0 0-1 .75 3 3 0 0 0-1.47-.65 3.18 3.18 0 0 0-2 .42 2.56 2.56 0 0 0-1 1.15 3 3 0 0 0-.9-.36 3.25 3.25 0 0 0-2 .43 3.5 3.5 0 0 0-1 .93l-3.73-6.46a3.52 3.52 0 0 0-4.88-1.31 3.59 3.59 0 0 0-1.31 4.88l6.15 10.65a4.91 4.91 0 0 0-3.82-1A3.83 3.83 0 0 0 12.95 29a5 5 0 0 0 1.89 2.49 57.22 57.22 0 0 0 15 8.67.91.91 0 0 0 .73-.07l10.45-6a.9.9 0 0 0 .37-.42 11.23 11.23 0 0 0 .5-5.52zm-2.08 4.55l-9.76 5.63A56.85 56.85 0 0 1 16 30.1a3.42 3.42 0 0 1-1.29-1.54 2 2 0 0 1 1.16-2.09 2.94 2.94 0 0 1 2.24.69l3.32 2.2a.89.89 0 0 0 1.26-1.2l-8-13.93a1.76 1.76 0 0 1 .65-2.44 1.76 1.76 0 0 1 2.44.65l4.69 8.13a.89.89 0 0 0 1.67-.51 1.92 1.92 0 0 1 .81-1.44 1.72 1.72 0 0 1 .9-.2 1.1 1.1 0 0 1 .93.69.89.89 0 0 0 1.67-.49 1 1 0 0 1 .44-1.24 1.81 1.81 0 0 1 .86-.18 1.1 1.1 0 0 1 1 .67.89.89 0 0 0 1.63-.19 2.25 2.25 0 0 1 .74-.68c1-.42 1.8-.11 2.8.85a13.27 13.27 0 0 1 2.72 4.54 24.1 24.1 0 0 1 1.47 6 10.53 10.53 0 0 1-.3 4.31zM5.54.25A.84.84 0 0 0 4.92 0a.85.85 0 0 0-.63.25l-4 4a.91.91 0 0 0 0 1.27.92.92 0 0 0 1.27 0L4 3v17.19a.88.88 0 0 0 1.76 0V3l2.5 2.5a.92.92 0 0 0 1.27 0 .87.87 0 0 0 .25-.63.88.88 0 0 0-.27-.64z"/></svg>
      <p class="message">
        Swipe omhoog om jouw pakket retour te sturen
      </p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'SwipeAwayMessage'
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 6000ms cubic-bezier(.19,1,.22,1) 3s;
  will-change: opacity;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.swipe-away-message {
  position: absolute;
  top: 240px;
  width: 250px;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 5;
  text-align: center;
  pointer-events: none;

  @media (max-width: 479px) {
    top: 150px;
    width: 230px;
  }
}

@keyframes arrowUp {
  0% {
    transform: translateY(0px);
    opacity: 0;
  }
  33%, 66% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translateY(-8px);
  }
}

.icon {
  position: relative;
  top: 0;
  left: 16px;
  animation: arrowUp 1700ms infinite;
}

.message {
  color: white;
  background-color: rgba(#022333, 0.8);
  line-height: 1.2;
  font-size: 16px;
  font-weight: $fw-medium;
  padding: 10px 18px 12px;
  border-radius: 30px;

  @media (max-width: 479px) {
    font-size: 14px;
  }
}
</style>
